const KNOWN_FEATURES = {
  CALENDLY_SCHEDULE_APPOINTMENT: 'calendly_schedule_appointment',
  ENTERPRISE_LEGACY_REPORT: 'enterprise_legacy_report',
  REPORT_ENGINE: 'report_engine',
  SET_GOALS_MODAL: 'set_goals_component',
  BOOK_A_MEETING_PROMO: 'book_a_meeting_component',
  INSIGHTS_MENU: 'insights',
  CAMPAIGNS_MENU: 'campaigns',
  POSTS_MENU: 'organic_posts',
  ACTIVITY_CENTER_MENU: 'activity_center',
  AI_AGENTS_MENU: 'ai_agents',
  CONNECTIONS_MENU: 'connections',
  BOOK_A_MEETING_MENU: 'book_a_meeting',
  SHARE_REPORT: 'share_report',
  SKIP_ONBOARDING: 'skip_onboarding',
  KNOWLEDGE_HUB_MENU: 'knowledge_hub',
  MARKETPLACE_MENU: 'marketplace',
  DEMO_MODE: 'demo_mode',
  ALLOW_GOAL_EDITING: 'allow_goal_editing',
  // temp feature flags for organic posts
  SCHEDULE_ORGANIC_POSTS: 'schedule_organic_posts',
  ORGANIC_POST_INSIGHTS: 'organic_post_insights',
  DATA_EXPLORER_MENU: 'data_explorer',
  ASK_ME_ANYTHING: 'ask_me_anything',
  LINKEDIN_ORGANIC_POSTS: 'linkedin_organic_posts',
  LINKEDIN_ADS: 'linkedin_ads',
}

const KNOWN_SUB_FEATURES = {
  ACTIVITY_CENTER: {
    LIST_ACTIVITIES: 'list_activities',
    LIST_ORDERS: 'list_orders',
  },
}

export {
  KNOWN_FEATURES,
  KNOWN_SUB_FEATURES,
}
